import { Platform } from 'react-native';
import { FACEBOOK_CLICK_ID, CURRENT_GUEST_DATA } from './constants';
import { IGuest } from '../../components/consumer/booking/GuestBooking/types';
import type { FacebookUserData } from '../../../../packages/analytics/trackers/FacebookTracker';

const findAndSetFacebookClickId = () => {
  if (window.location.search && !sessionStorage.getItem(FACEBOOK_CLICK_ID)) {
    const params = new URL(window.location.href).searchParams;
    const fbclid = params.get('fbclid');
    if (fbclid) {
      sessionStorage
        .setItem(FACEBOOK_CLICK_ID, fbclid);
    }
  }
};

export const getFacebookClickId = () => {
  if (Platform.OS !== 'web' || typeof sessionStorage.getItem !== 'function') {
    return null;
  }
  findAndSetFacebookClickId();
  return { fbc: sessionStorage.getItem(FACEBOOK_CLICK_ID) };
};

export const getFacebookRequiredUserData: (
  loggedInUserData: any,
) => FacebookUserData = loggedInUserData => {
  if (Platform.OS !== 'web' || typeof sessionStorage.getItem !== 'function') {
    return null;
  }
  const loggedInUser: any = loggedInUserData.value;
  const guestUser: String = sessionStorage.getItem(CURRENT_GUEST_DATA);
  const fbClickId: Object = getFacebookClickId();
  let userData: IGuest;
  if (guestUser && !loggedInUser.isLogin && typeof guestUser === 'string') {
    userData = JSON.parse(guestUser);
    userData.phoneNumber = `1${userData.phoneNumber}`;
  } else {
    userData = {
      firstName: loggedInUser.first_name,
      lastName: loggedInUser.last_name,
      email: loggedInUser.email,
      phoneNumber: loggedInUser.phone_number ? `1${loggedInUser.phone_number}` : loggedInUser.phone_number,
    };
  }
  return { ...userData, ...fbClickId };
};
